import {
  isUserWithRoles, useCombinedUser, useIsMsalAuth, useIsUserAuth, UserRoles,
} from '@equifinance/shared';
import { useMemo } from 'react';
import { useAccountContext } from '../../../contexts';

export default function useDownloadEsisLink() {
  const isInternalUser = useIsMsalAuth();
  const isExternalUser = useIsUserAuth();
  const { user } = useCombinedUser();
  const { account: { status } } = useAccountContext();

  const isUnderwriter = isInternalUser && isUserWithRoles([UserRoles.UNDERWRITER], user);
  const isSalesSupport = isInternalUser && isUserWithRoles([UserRoles.SALES_SUPPORT], user);
  const isReadOnlyUser = isInternalUser && isUserWithRoles([UserRoles.READ_ONLY], user);
  const isBrokerAdmin = isExternalUser && isUserWithRoles([UserRoles.BROKER_ADMIN], user);
  const isBrokerUser = isExternalUser && isUserWithRoles([UserRoles.BROKER_USER], user);

  const isDisabled = useMemo(() => {
    if (isUnderwriter || isSalesSupport || isBrokerAdmin || isBrokerUser) {
      return status !== 'WithBroker' && status !== 'WithLender';
    }

    if (isReadOnlyUser) {
      return true;
    }

    return false;
  }, [status]);

  return {
    isDisabled,
  };
}
